<template>
    <div :class="$style.wrapper">
        <div :class="$style.layout">
            <div :class="$style.left">
                <h4>QR Code Redirect URL</h4>
                <div :class="$style.qrcode">
                    <img :src="qrcode" />
                </div>
                <ol>
                    <li>
                        Scan this code with your mobile device's QR scanner app.
                    </li>
                    <li>Open the displayed link in your mobile web browser.</li>
                    <li>Upload one or more files using your mobile device.</li>
                    <li>
                        All uploaded files will then be available in the list on
                        the right.
                    </li>
                </ol>
            </div>

            <div :class="$style.right">
                <h4>My Recent Uploads</h4>
                <flex-table
                    id-field="uid"
                    :data="allUploads"
                    :searchable="false"
                    :row-click-enabled="true"
                    :height="330"
                >
                    <flex-table-column
                        label="Uploaded"
                        field="date_entered"
                        data-type="date"
                        sort="desc"
                        :width="150"
                    >
                        <template v-slot:row="{ data }">
                            <i
                                v-if="data.isNew"
                                v-popover="'This file was just uploaded'"
                                class="fa-solid fa-check-circle"
                            />

                            {{ data.time_ellapsed }}
                        </template>
                    </flex-table-column>

                    <flex-table-column label="File" field="file">
                        <template v-slot:row="{ file, data }">
                            <div v-if="data.pending">
                                <i class="icon-spinner" />
                                <span style="font-style: italic; color: #999"
                                    >uploading...</span
                                >
                            </div>
                            <a
                                v-else
                                target="_blank"
                                :href="file.url"
                                :title="file.name"
                                v-text="file.name"
                            />
                        </template>
                    </flex-table-column>

                    <flex-table-column :width="80">
                        <template v-slot:row="{ data }">
                            <div
                                v-if="!data.pending"
                                style="text-align: center"
                            >
                                <button
                                    type="button"
                                    class="btn btn-default btn-sm"
                                    @click="onSelectFile(data.file)"
                                >
                                    Select
                                </button>
                            </div>
                        </template>
                    </flex-table-column>
                </flex-table>
            </div>
        </div>
    </div>
</template>

<script>
import qrcode from 'qrcode';
import FlexTable from 'larasnap/assets/vue/flextable/FlexTable.vue';
import FlexTableColumn from 'larasnap/assets/vue/flextable/FlexTableColumn.vue';
import { listen } from 'larasnap/echo';
import { moment } from 'larasnap/support';

export default {
    components: {
        FlexTable,
        FlexTableColumn,
    },
    props: {
        url: String,
        uploads: Array,
    },
    data() {
        return {
            qrcode: null,
            newUploads: [],
            pendingUploads: [],
        };
    },
    computed: {
        allUploads() {
            const newUploads = this.newUploads.map(upload => ({
                ...upload,
                isNew: true,
            }));

            return [...this.pendingUploads, ...this.uploads, ...newUploads].map(
                upload => ({
                    ...upload,
                    time_ellapsed: moment(upload.date_entered).fromNow(),
                }),
            );
        },
    },
    created() {
        this.setRedirectUrl(this.url);
        this.listenForMobileUploadInProcess();
        this.listenForMobileUploadComplete();
        this.setQrCodeRefreshInterval();
    },
    methods: {
        setQrCodeRefreshInterval() {
            const INTERVAL = 10 * 60 * 1000; // 10 minutes
            const id = setInterval(() => {
                $(this.$el)
                    .panel()
                    .$http('get-mobile-redirect-url')
                    .send()
                    .then(({ data: url }) => this.setRedirectUrl(url));
            }, INTERVAL);

            this.$once('hook:destroyed', () => clearInterval(id));
        },
        setRedirectUrl(url) {
            qrcode.toDataURL(url).then(url => (this.qrcode = url));
        },
        onSelectFile(file) {
            $(this.$el).panel().onSelectFile(file);
        },
        listenForMobileUploadInProcess() {
            const stopListening = listen(
                '.MobileUploadInProcess',
                ({ fileCount }) => {
                    this.pendingUploads = Array.from({ length: fileCount }).map(
                        (_, i) => ({
                            uid: `pending-${i}`,
                            date_entered: moment().format('datetime'),
                            pending: true,
                        }),
                    );
                },
            );
            this.$once('hook:destroyed', stopListening);
        },
        listenForMobileUploadComplete() {
            const stopListening = listen(
                '.MobileUploadComplete',
                ({ files }) => {
                    this.pendingUploads = [];
                    this.newUploads.push(...files);
                },
            );
            this.$once('hook:destroyed', stopListening);
        },
    },
};
</script>

<style lang="scss" module>
.layout {
    display: grid;
    grid-template-columns: [col] 40% [col] 60%;
    grid-template-rows: [row] auto;

    .left {
        margin-right: 20px;

        ol li {
            margin: 5px 5px;
        }
    }

    h4 {
        margin-top: 0;
        text-align: center;
    }
    .qrcode {
        text-align: center;
    }
}
</style>
